import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
// @material-ui/icons
import Clear from "@material-ui/icons/Clear";
import Check from "@material-ui/icons/Check";
// core components
import styles from "assets/jss/components/customInputStyle.js";

const useStyles = makeStyles(styles);

export default function CustomInput(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    success,
    helperText,
  } = props;

  const onChange=(e)=> {
    e.currentTarget.value = checkChara(inputProps.type, e.currentTarget.value);
    if(inputProps.onChange) inputProps.onChange(e);
  };

  function checkChara(_type,_str){
    var tmp = _str.split("");
    for(var cnt=0;cnt<tmp.length;cnt++){
      switch(_type){
        case "katakana":
          if(tmp[cnt].match(/^[ァ-ヶー]*$/)==null){
            tmp[cnt] = "";
          }
          break;
        case "hankaku":
          if(tmp[cnt].match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/)==null){
            tmp[cnt] = "";
          }
          break;
        case "number":
          if(tmp[cnt].match(/^[0-9]+$/)==null){
            tmp[cnt] = "";
          }
          break;
        default:
          break;
      }
    }
    return tmp.join("");
  }

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error
  });
  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
  });
  const marginTop = classNames({
    [classes.marginTop]: labelText === undefined
  });
  return (
    <FormControl
      fullWidth={true}
      {...formControlProps}
      className={classes.formControl}
    >
      {labelText !== undefined ? (
        <InputLabel
          className={classes.labelRoot + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {labelText} {labelProps && labelProps.key ? <b>[{labelProps.key}]</b> : null}
        </InputLabel>
      ) : null}
      <Input
        classes={{
          root: marginTop,
          disabled: classes.disabled,
          underline: underlineClasses
        }}
        id={id}
        {...inputProps}
        onChange={e=> onChange(e)}
      />
      {error ? (
        <Clear className={classes.feedback + " " + classes.labelRootError} />
      ) : success ? (
        <Check className={classes.feedback + " " + classes.labelRootSuccess} />
      ) : null}
      { helperText ? <FormHelperText>{helperText}</FormHelperText> : null }
    </FormControl>
  );
}

CustomInput.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool,
  helperText: PropTypes.node,
};
